import { z } from "zod";
import { ReviewThemeSchema } from "./reviewThemes.ts";

const ThemeSentimentSchema = z.enum(["Positive", "Mixed", "Negative"]);

const SentimentCountSchema = z.object({
    sentiment: ThemeSentimentSchema,
    count: z.number().int().nonnegative()
});

const ReviewThemeWithCountsSchema = z.object({
    themeType: ReviewThemeSchema,
    sentimentCounts: z.array(SentimentCountSchema),
    totalCount: z.number().int().nonnegative()
});
export type ReviewThemeWithCounts = z.infer<typeof ReviewThemeWithCountsSchema>;

export const ThemeSentimentClassSchema = z.enum(["strength", "watchArea", "toMonitor"]);
export type ThemeSentimentClass = z.infer<typeof ThemeSentimentClassSchema>;

export const HEADLINE_THEME_LIMIT = 2;

const ThemeHeadlineSchema = z.object({
    kind: ThemeSentimentClassSchema,
    themeTypes: z.array(ReviewThemeSchema).max(HEADLINE_THEME_LIMIT)
});
export type ThemeHeadline = z.infer<typeof ThemeHeadlineSchema>;

export const ReviewThemesWithCountsSchema = z.object({
    strengths: z.array(ReviewThemeWithCountsSchema),
    opportunities: z.array(ReviewThemeWithCountsSchema),
    contributingCount: z.number().int().nonnegative(),
    headlines: z
        .array(ThemeHeadlineSchema)
        .length(ThemeSentimentClassSchema.options.length)
        .refine(headlines => headlines.every((headline, index) => headline.kind === ThemeSentimentClassSchema.options[index]), "headlines must carry each sentiment class once, in display order"),
    totalMentions: z.number().int().nonnegative()
});
export type ReviewThemesWithCounts = z.infer<typeof ReviewThemesWithCountsSchema>;
